/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import userReducer from "./slices/userSlice";
import cartReducer from "./slices/cartSlice";
import appReducer from "./slices/appSlice";
import loadReducer from "./slices/loadSlice";
import alertReducer from "./slices/alertSlice";

import { ordersApi } from "./services/orders";
import { licensesApi } from "./services/licenses";
import { productsApi } from "./services/products";
import { profileApi } from "./services/profile";
import { refundsApi } from "./services/refunds";
import { dtCreditsApi } from "./services/dtCreditsApi"; // S428: DT credits
import { wordBalanceApi } from "./services/wordBalanceApi"; // S585: TSL word balance
import { legacyOrdersApi } from "./services/legacyOrders"; // S725: old-store order history
import { dtRateApi } from "./services/dtRateApi"; // Document Translator rate, read from the back end

export const store = configureStore({
  reducer: {
    [ordersApi.reducerPath]: ordersApi.reducer,
    [licensesApi.reducerPath]: licensesApi.reducer,
    [productsApi.reducerPath]: productsApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [refundsApi.reducerPath]: refundsApi.reducer,
    [dtCreditsApi.reducerPath]: dtCreditsApi.reducer,  // S428
    [wordBalanceApi.reducerPath]: wordBalanceApi.reducer,  // S585
    [legacyOrdersApi.reducerPath]: legacyOrdersApi.reducer,  // S725
    [dtRateApi.reducerPath]: dtRateApi.reducer,
    user: userReducer,
    cart: cartReducer,
    app: appReducer,
    load: loadReducer,
    alert: alertReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(ordersApi.middleware)
      .concat(licensesApi.middleware)
      .concat(productsApi.middleware)
      .concat(profileApi.middleware)
      .concat(refundsApi.middleware)
      .concat(dtCreditsApi.middleware)  // S428
      .concat(wordBalanceApi.middleware)  // S585
      .concat(legacyOrdersApi.middleware)  // S725
      .concat(dtRateApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
setupListeners(store.dispatch);
